module.exports = __webpack_public_path__ + "img/PigPug_EGM.06889c5d.png";